// Empty polyfill module to exclude unnecessary polyfills for modern browsers
// These features (Array.at, Array.flat, Object.fromEntries, etc.) are natively supported
// in modern browsers (Chrome 92+, Safari 15.4+, Firefox 90+)
module.exports = {};

